import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 商卡事件名称常量
export const PRODUCT_CARD_EVENT_NAMES = {
  MAIN_IMAGE_LOAD_ERROR: 'main_image_load_error', //商卡主图加载失败
  PRODUCT_CARD_CLICK: 'product_card_click', //商卡点击事件
  ADD_CART_BUTTON_CLICK: 'add_cart_button_click', // 添加购物车按钮点击事件
  NOTIFY_BUTTON_CLICK: 'notify_button_click', // 通知按钮点击事件
  WISH_BUTTON_CLICK: 'wish_button_click', // 心愿单按钮点击事件
  PARAMS_ERROR: 'params_error', // 商卡入参错误
};

export enum PRODUCT_CARD_TYPE {
  TYPE_1 = 'type_1',
  TYPE_2 = 'type_2',
  TYPE_3 = 'type_3',
}

export enum PRODUCT_CARD_PARAMS_ERROR {
  N_PD = 'n_pd',
  N_SKU = 'n_sku',
  N_IMG = 'n_img',
  N_R = 'n_r',
  N_C = 'n_c',
}

// 导出类型定义，既可以当常量用也可以当类型用
export type ProductCardEventNames = typeof PRODUCT_CARD_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = ['params_error'];

// 基础 Business Logger 实例 - 使用泛型约束事件名称
export const productCardBusinessLogger = createBusinessLogger<ProductCardEventNames>(
  'product_card',
  categoryNames,
);
